// apps/client/src/api/token.ts — bearer token on the device (spec §6.3); memory fallback when storage is unavailable
const KEY = 'whiskerton-token';
let memory: string | null = null;
export function getToken(): string | null { try { return localStorage.getItem(KEY) ?? memory; } catch { return memory; } }
export function setToken(t: string): void { memory = t; try { localStorage.setItem(KEY, t); } catch { /* memory only */ } }
export function clearToken(): void { memory = null; try { localStorage.removeItem(KEY); } catch { /* memory only */ } }
